<template>
	<div class="enterprisewebsite"  v-title :data-title="msg">
		<headerbar :curindex="curindex"></headerbar>
	 <div class="industrial-list">
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en mgbn">
						<h2 class="title">投资动态</h2> 
					</div>
					<div class="pro-indynalist" >
						<div class="titlebox flexcss flexcssfour">
							<h5 :class="toipsbtn != 1?'title nocur':'title'" @click="toipsbtn=1">重点企业投资动态</h5>
							<h5 :class="toipsbtn != 2?'title nocur':'title'" @click="toipsbtn=2">风险投资最新动态</h5> 
							<h5 :class="toipsbtn != 3?'title nocur':'title'" @click="toipsbtn=3">可研项目</h5>
							<h5 :class="toipsbtn != 4?'title nocur':'title'" @click="toipsbtn=4">购地投资最新动态</h5>
						</div>
						<div  v-show="toipsbtn == 1" class="pro_tablelist" style="padding-bottom:50px">  
							<table border="0" cellspacing="0" cellpadding="0">
								<tr><th>时间</th><th>公司</th><th>项目</th><th>金额</th></tr>
								<tr v-for="item in pagedata.invest">
									<td>{{item.date}}</td>
									<td  @click="routerlinkid('/enterprises',item.stockCode)"><span :class="item.stockCode!=0?'curp':''">{{item.title}}</span></td>
									<td :data="item.id">{{item.projectName}}</td>
									<td>{{item.money}}</td>
									<!-- <td>{{item.area}}</td> -->
								</tr>
							</table> 
						</div>
						<div  v-show="toipsbtn == 2" class="pro_tablelist" style="padding-bottom:50px">
							<table border="0" cellspacing="0" cellpadding="0">
								<tr><th>项目名称</th><th>公司名称</th><th>地区</th><th>投资轮次</th><th>投资时间</th><th>投资金额</th><th>投资方</th></tr>
								<tr v-for="item in pagedata.financing">
									<td>{{item.projectName}}</td>
									<td @click="routerlinkid('/enterprises',item.stockCode)" class="curp">{{item.enterpriseName}}</td>
									<td>{{item.area}}</td>
									<td>{{item.rount}}</td>
									<td>{{item.time}}</td>
									<td>{{item.amount}}</td>
									<td><span v-for="tor in item.orgList" :class="tor.id!=0?'curp':''" @click="routerlinkid('/investement-enterprises',tor.id)">{{tor.orgName}},</span></td> 
								</tr>
							</table> 
						</div>
						<div  v-show="toipsbtn == 3" class="pro_tablelist" style="padding-bottom:0">
							<table border="0" cellspacing="0" cellpadding="0">
								<tr><th>项目名称</th><th>投资企业</th><th>所属概念</th></tr>
								<tr v-for="item in festudylist">
									<td><span class="curp" @click="routerlinkid('/news',item.id)">{{item.title}}</span></td>
									<td>
										<span class="curp" @click="routerlinkid('/enterprises',item.stockCode)">{{titlesubstr(item.title)}}</span>
										<span v-if="!item.stockCode">{{titlesubstr(item.title)}}</span> 
									</td>
									<td>{{item.notion}}</td>
									<!-- <td><span class="curp">详情</span></td> -->
								</tr>
							</table>
							<!-- <div class="hasmorepage" v-show="hasmoreproject"   @click="addlandlist">—— 点击查看更多 ——</div> -->
						</div>
						<div  v-show="toipsbtn == 4" class="pro_tablelist" style="padding-bottom:0">
							<table border="0" cellspacing="0" cellpadding="0">
								<tr><th>行政区</th><th>项目名称</th><th>总面积(亩)</th><th>总金额(万元)</th><th>土地用途</th><th>土地使用权人</th><th>签定日期</th></tr>
								<tr v-for="item in landlist">
									<td>{{item.area}}</td>
									<td>{{item.projectName}}</td>
									<td>{{item.size}}{{item.sizeUnit}}</td>
									<td>{{item.amount}}{{item.amountUnit}}</td>
									<td>{{item.purpose}}</td>
									<td :class="item.stockCode!=''?'curp':''" @click="routerlinkid('/enterprises',item.stockCode)">{{item.owner}}</td>
									<td>{{item.time}}</td>
									<!-- <td><span class="curp">详情</span></td> -->
								</tr>
							</table>
							<div class="hasmorepage" v-show="hasmoreland"   @click="addlandlist">—— 点击查看更多 ——</div>
						</div>
					</div>
				</div> 
			</div> 
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en mgbn">
						<h2 class="title">投资标的推荐</h2> 
					</div>
					<div class="inve-companylist">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table ">
							<tr>
								<th>企业名称</th>
								<th>所属行业</th>
								<th>画像标签</th>
								<!-- <th>星级</th> -->
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th> 
							</tr>
							<tr v-for="list in enterpristlistlocal">
								<td class="title"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
										<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',3,'notion',item.id,item.name)">{{item.name}}</span> 
								</td> 
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td> 
								<td class="conpanytags hastag1" v-show="list.tag!=''"> 
										<span class="span-tag" v-for="item in list.taglist"  @click="tagrouter('/enterpriseTag',3,'tag',item.id,item.name)">{{item.name}}</span> 
								</td>
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td> 
								<!-- <td>
									<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0 " >
										<img src="../../assets/starfull.png" alt="" v-for="item in list.star">
										<img src="../../../../assets/star.png" alt="" v-for="item in (5-list.star)">
									</p>
									<span v-if="list.star == 0">-</span>
								</td> -->
								<td  v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td> 
								<td  v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td> 
								<td  v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>  
								<td>{{list.area}}</td>
								<td class="orglist" >
									<p v-if="list.financingRound.length>0"><span v-for="(org,inds) in list.financingRound[0].orgList" data="org.id" :class="org.id!=0?'curp':''" @click="routerlinkid('/investement-enterprises',org.id)">
									{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
									<p v-if="list.financingRound.length==0">-</p>
								</td>  
							</tr>
						</table>
						<div class="hasmorepage" v-show="haspage" @click="addenterpriselist()">—— 点击查看更多 ——</div>
					</div> 
				</div>
			</div>
		<!--  --> 
		</div> 
			
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'inveprojectList',
	  data(){return{
				msg:"投资项目",
				curindex:4,
				toipsbtn:1,
				pagedata:{financing:[],invest:[],land:[]}, festudylist:[],
				landpage:1,
				hasmoreland:true,
				landlist:[],
				enterpristlist:[],
				enterpristlistlocal:[],
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				total1: 0, //记录总数
				totalPage:2,
				maxPage:10,  //最大页数 
				usertaglist:[],usernotionlistsave:[],provienceid:0,cityid:0,
			}},
			created(){
				
				this.getuserinfor();
				this.getpagedatalist();
				this.getenterpriselist(1);
			},
		mounted() {},
		methods:{
			//公用部分
			getuserinfor(){
				this.bus.$emit('loading',true); 
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				};
			this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
			this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion);
			},
			jsondouhao(name,data){
				var notionja="",douhao='%2C';
				if(data.length == 0){
					return notionja;
				}  
				for(var i=0;i<data.length;i++){ 
					if(i==data.length-1){
						douhao='';
					}
					notionja+=data[i].id+douhao;
				}
				notionja='&'+name+'='+notionja;
				return notionja; 
			},
			getpagedatalist(){
				var _this=this;
				this.$axios.get(this.$api.cyl.enterpriseEdition.investdynamic(),{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					console.log(res.data.data) 
					_this.pagedata=res.data.data;   
					_this.landlist=res.data.data.land;
				}); 
				this.$axios.get(this.$api.cyl.news.list()+"?reportType=29002&notionList="+this.userdata.notion,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log(res.data) 
					if(res.data.success){
						_this.festudylist=res.data.list;
					}
				});
			},
			getenterpriselist(ajpage){
				var _this=this;
				var notionja=_this.jsondouhao('notion',this.usernotionlistsave);
				var tagaja=_this.jsondouhao('tag',this.usertaglist); 
				this.$axios.get(this.$api.cyl.enterprise.list()+'?type=2&city='+this.cityid+'&province='+this.provienceid+notionja+tagaja+'&page='+ajpage,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					// console.log(res.data) ; 
					if(res.data.success){  
								_this.enterpristlist=res.data.list;
								for(var i=0;i<res.data.list.length;i++){
									_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode);
									_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
									//创新企业专属 
									if(_this.enterpristlist[i].financingRound == null ){
										_this.enterpristlist[i].financingRound=[];
									};
									_this.enterpristlistlocal.push(_this.enterpristlist[i]);
								} 
							
									_this.bus.$emit('loading',false); 
									_this.totalPage=res.data.totalPage; 
								// 	_this.pageSize=res.data.pageSize; 
								// _this.total=res.data.totalRecord;
								// 	_this.shownoresults=false;  
									_this.haspage=res.data.totalPage>_this.page;
									//导航栏筛选
									// var citylistd=[],citytest=res.data.cityList;
									// for(var i=0;i<citytest.length;i++){
									// 	let citylista ={}; 
									// 	citylista.value=citytest[i].count;  
									// 	citylista.id=citytest[i].id;  
									// 	citylista.name=_this.citynameremove(citytest[i].name);  
									// 	citylista.data=[];
									// 	for(var p=0;p<citytest[i].children.length;p++){
									// 		let citydtac={};
									// 		citydtac.value=citytest[i].children[p].count;
									// 		citydtac.id=citytest[i].children[p].id;
									// 		citydtac.name=citytest[i].children[p].name;
									// 		citylista.data.push(citydtac); 
									// 	}
									// 	citylistd.push(citylista); 
									// };   
									// if(_this.notioneditbtn){
									// 	_this.selectcitydata=res.data.cityList;
									// 	_this.citymapdata=citylistd; 
									// 	_this.total1=res.data.totalRecord;  
									// }   
									// if(_this.notioncodebtn){
									// 	_this.notioncodebtn=false; 
									//  _this.notionlistnumber(_this.notionlist,res.data.extend.notionList);
									// } 
					}else{ 
						
					} 
				});
			},
			addenterpriselist(){
				this.page++;
				this.getenterpriselist(this.page);  
			},
			titlesubstr(title){
				var titlearry=title.split('_');
				if(titlearry.length>0){return titlearry[0]};
			},
			addlandlist(){
				this.landpage++;
				var _this=this;
				if(this.landpage>49){return;}
				this.$axios.get(this.$api.cyl.land.list()+'?page='+this.landpage,{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
					// console.log(res.data.list);
					for(var i=0;i<res.data.list.length;i++){
						_this.landlist.push(res.data.list[i]);
					}
				});  
			},
		}
	}
	
	
	
</script>

<style >
	
</style>   
